import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionEventInfo = styled.span.attrs({
  id: 'descriptionEventInfo',
})<React.CSSProperties>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['light']};
  font-size: ${30 * Screen.widthRatio}px;
  line-height: ${36 * Screen.widthRatio}px;
  max-width: ${843 * Screen.widthRatio}px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

export default DescriptionEventInfo;
